export const INVITES_LIST_REQUEST = 'INVITES_LIST_REQUEST';
export const INVITES_LIST_SUCCESS = 'INVITES_LIST_SUCCESS';
export const INVITES_LIST_ERROR = 'INVITES_LIST_ERROR';

export const INVITE_REQUEST = 'INVITE_REQUEST';
export const INVITE_SUCCESS = 'INVITE_SUCCESS';
export const INVITE_ERROR = 'INVITE_ERROR';

export const RESEND_INVITE_REQUEST = 'RESEND_INVITE_REQUEST';
export const RESEND_INVITE_SUCCESS = 'RESEND_INVITE_SUCCESS';
export const RESEND_INVITE_ERROR = 'RESEND_INVITE_ERROR';

export const VALIDATE_REQUEST = 'VALIDATE_REQUEST';
export const VALIDATE_SUCCESS = 'VALIDATE_SUCCESS';
export const VALIDATE_ERROR = 'VALIDATE_ERROR';

export const ACCEPT_INVITE_REQUEST = 'ACCEPT_INVITE_REQUEST';
export const ACCEPT_INVITE_SUCCESS = 'ACCEPT_INVITE_SUCCESS';
export const ACCEPT_INVITE_ERROR = 'ACCEPT_INVITE_ERROR';

export const FEEDBACK_REQUEST = 'FEEDBACK_REQUEST';
export const FEEDBACK_SUCCESS = 'FEEDBACK_SUCCESS';
export const FEEDBACK_ERROR = 'FEEDBACK_ERROR';
export const RESET_BLOCK_MANAGER = 'RESET_BLOCK_MANAGER';

export const ALL_USERS_REQUEST = 'ALL_USERS_REQUEST';
export const ALL_USERS_SUCCESS = 'ALL_USERS_SUCCESS';
export const ALL_USERS_ERROR = 'ALL_USERS_ERROR';

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_ERROR = 'USER_DETAILS_ERROR';

const block = {
  loading: false,
  success: false,
  error: null,
};

const initialState = {
  userInfo: null,
  invites: {
    ...block,
    list: [],
  },
  inviteEmployee: {
    ...block,
  },
  sendInvite: {
    ...block,
  },
  resendInvite: {
    ...block,
  },
  validate: {
    ...block,
  },
  acceptInvite: {
    ...block,
  },
  feedback: {
    ...block,
  },
  allUsers: {
    ...block,
    users: [],
  },
  useDetails: {
    ...block,
    details: {},
  },
};

export const ManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVITES_LIST_REQUEST:
      return { ...state, invites: { ...state.invites, loading: true } };
    case INVITES_LIST_SUCCESS:
      return {
        ...state,
        invites: {
          ...state.invites,
          loading: false,
          success: true,
          list: action.inviteList,
          error: null,
        },
      };
    case INVITES_LIST_ERROR:
      return {
        ...state,
        invites: { ...state.invites, loading: false, error: action.error },
      };
    case INVITE_REQUEST:
      return { ...state, sendInvite: { ...state.sendInvite, loading: true } };
    case INVITE_SUCCESS:
      return {
        ...state,
        sendInvite: {
          ...state.sendInvite,
          loading: false,
          success: true,
          error: null,
        },
        invites: {
          ...state.invites,
          list: [...state.invites.list, action.data],
        },
      };
    case INVITE_ERROR:
      return {
        ...state,
        sendInvite: {
          ...state.sendInvite,
          loading: false,
          error: action.error,
        },
      };
    case RESEND_INVITE_REQUEST:
      return {
        ...state,
        resendInvite: { ...state.resendInvite, loading: true },
      };
    case RESEND_INVITE_SUCCESS:
      return {
        ...state,
        resendInvite: {
          ...state.resendInvite,
          loading: false,
          success: true,
          error: null,
        },
      };
    case RESEND_INVITE_ERROR:
      return {
        ...state,
        resendInvite: {
          ...state.resendInvite,
          loading: false,
          error: action.error,
        },
      };

    case VALIDATE_REQUEST:
      return {
        ...state,
        validate: { ...state.validate, loading: true },
      };
    case VALIDATE_SUCCESS:
      return {
        ...state,
        userInfo: action.userInfo,
        validate: {
          ...state.validate,
          loading: false,
          success: true,
          error: null,
        },
      };
    case VALIDATE_ERROR:
      return {
        ...state,
        validate: {
          ...state.validate,
          loading: false,
          error: action.error,
        },
      };
    case ACCEPT_INVITE_REQUEST:
      return {
        ...state,
        acceptInvite: { ...state.acceptInvite, loading: true },
      };
    case ACCEPT_INVITE_SUCCESS:
      return {
        ...state,
        acceptInvite: {
          ...state.acceptInvite,
          loading: false,
          success: true,
          error: null,
        },
      };
    case ACCEPT_INVITE_ERROR:
      return {
        ...state,
        acceptInvite: {
          ...state.acceptInvite,
          loading: false,
          error: action.error,
        },
      };

    case FEEDBACK_REQUEST:
      return {
        ...state,
        feedback: { ...state.feedback, loading: true },
      };
    case FEEDBACK_SUCCESS:
      return {
        ...state,
        feedback: {
          ...state.feedback,
          loading: false,
          success: true,
          error: null,
        },
      };
    case FEEDBACK_ERROR:
      return {
        ...state,
        feedback: {
          ...state.feedback,
          loading: false,
          success: false,
          error: action.error,
        },
      };

    case RESET_BLOCK_MANAGER:
      return { ...state, [action.block]: { ...state[action.block], ...block } };
    case ALL_USERS_REQUEST:
      return { ...state, allUsers: { ...state.allUsers, loading: true } };
    case ALL_USERS_SUCCESS:
      return {
        ...state,
        allUsers: {
          ...state.allUsers,
          loading: false,
          success: true,
          list: action.list,
          error: null,
        },
      };
    case ALL_USERS_ERROR:
      return {
        ...state,
        allUsers: { ...state.allUsers, loading: false, error: action.error },
      };
    case USER_DETAILS_REQUEST:
      return { ...state, useDetails: { ...state.useDetails, loading: true } };
    case USER_DETAILS_SUCCESS:
      return {
        ...state,
        useDetails: {
          ...state.useDetails,
          loading: false,
          success: true,
          details: action.data,
          error: null,
        },
      };
    case USER_DETAILS_ERROR:
      return {
        ...state,
        useDetails: {
          ...state.useDetails,
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};
